module.exports = __webpack_public_path__ + "img/pagination-waterSavings.5070c8aa.svg";